import { Flex } from "antd";
import { FC, useMemo } from "react";
import { Product } from "tm-shared/types";
import { buildRoutePath } from "tm-shared/utils";

import { ROUTES } from "@/constants";
import { useCatalog } from "@/domains/product";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledProductItem, StyledProductsList } from "./Styled";

interface ProductsProps {
    barcodes: string[];
}

export const Products: FC<ProductsProps> = ({ barcodes }) => {
    const { products } = useCatalog();

    const items = useMemo(
        () =>
            barcodes
                .map((barcode) => products[barcode])
                .filter((p): p is Product => !!p),
        [barcodes, products],
    );

    if (!items.length) return null;

    return (
        <Flex vertical gap={8}>
            <StyledProductsList>
                {items.map((product) => {
                    const { name, brand, capacity, alcohol_volume } =
                        product.params;

                    return (
                        <StyledProductItem
                            key={product.barcode}
                            to={buildRoutePath(ROUTES.ProductPage, {
                                barcode: product.barcode,
                            })}
                        >
                            <Flex vertical gap={2}>
                                <PrimaryText>{name.value}</PrimaryText>

                                {brand.value && (
                                    <SecondaryText fontSize={12}>
                                        {brand.value}
                                    </SecondaryText>
                                )}
                            </Flex>

                            <Flex
                                vertical
                                align="flex-end"
                                gap={2}
                                style={{ flexShrink: 0 }}
                            >
                                {capacity.value && (
                                    <SecondaryText fontSize={13}>
                                        {capacity.value} л
                                    </SecondaryText>
                                )}

                                {alcohol_volume.value && (
                                    <SecondaryText fontSize={12}>
                                        {alcohol_volume.value}
                                    </SecondaryText>
                                )}
                            </Flex>
                        </StyledProductItem>
                    );
                })}
            </StyledProductsList>
        </Flex>
    );
};
